<template>
  <div
    class="container"
    v-if="!loading"
  >
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-header">
            <h3>{{ site.name }}</h3>
            <h5>{{ site.domain }}</h5>
            {{ site.users }}
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th width="100%">{{ $t("gpool.table_name") }}</th>
                      <th>{{ $t("gpool.table_role") }}</th>
                      <th>{{ $t("gpool.table_actions") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="user in siteUsers"
                      :key="user.id"
                    >
                      <td>{{ user.id }}</td>
                      <td>{{ user.username }}</td>
                      <td>{{ $t(`gpool.role_${user.role}`) }}</td>
                      <td>
                        <button
                          class="btn btn-danger"
                          @click="
                            removeSiteUser({
                              site_id: site.id,
                              user_id: user.id
                            })
                          "
                        >
                          <i class="fa fa-minus"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th width="100%">{{ $t("gpool.table_name") }}</th>
                      <th>{{ $t("gpool.table_role") }}</th>
                      <th>{{ $t("gpool.table_actions") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="user in filteredUsers"
                      :key="user.id"
                    >
                      <td>{{ user.id }}</td>
                      <td>{{ user.username }}</td>
                      <td>{{ $t(`gpool.role_${user.role}`) }}</td>
                      <td>
                        <button
                          class="btn btn-success"
                          @click="
                            addSiteUser({ site_id: site.id, user_id: user.id })
                          "
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>Loading</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SiteUsers",
  computed: {
    filteredUsers() {
      return this.users.filter(user => {
        return !this.siteUsers.find(siteUser => siteUser.id === user.id);
      });
    },
    ...mapGetters("site", ["site", "siteUsers", "loading", "posting"]),
    ...mapGetters("user", ["users"])
  },
  beforeDestroy() {
    this.setLoading(true);
  },
  async created() {
    await this.getUsers();
    await this.getSiteAndUsers({ id: this.$route.params.id });
  },
  methods: {
    ...mapActions("site", [
      "getSiteAndUsers",
      "setLoading",
      "addSiteUser",
      "removeSiteUser"
    ]),
    ...mapActions("user", ["getUsers"])
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/SiteUsers.vue